//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";

import { logout, list, resetPassword, update, login } from "../comon/api/home";
export default {
  name: "Home",
  created() {
    this.obj = JSON.parse(localStorage.getItem("userInfos"));
    this._getList();
    this.ruleForm = JSON.parse(localStorage.getItem("userInfos"));
    // this.password = this.ruleForm.password;
    if (this.ruleForm.resetPasswd == 0 || this.ruleForm.resetPasswd == null) {
      this.centerDialogVisibles = true;
    }
  },
  watch: {
    password: function (val, oldVal) {
      this.ruleForm.password = val;
    }
  },
  data() {
    var validateTel = (rule, value, callback) => {
      if (value !== "") {
        let reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请填写正确的手机号码"));
        } else {
          // if (this.ruleForm.phone !== "") {
          // this.$refs["infoForm"].validateField("phone");
          // }
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      list: [],
      total: 0,
      centerDialogVisible: false,
      centerDialogVisibles: false,
      password: "",
      checkPwd: "",
      loading: false,
      input3: "",
      input4: "",
      isResetpwd: false,
      obj: JSON.parse(localStorage.getItem("userInfos")),
      ruleForm: {},
      rules: {
        phone: [
          //   { required: true, message: '请填写手机号码', trigger: 'blur' },
          { validator: validateTel, trigger: "blur" }
        ],
        email: [
          //   { required: true, message: '请填写电子邮箱', trigger: 'blur' },
          { type: "email", message: "请填写正确的电子邮箱", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    sendBtn1() {
      if (this.input3 == "") {
        this.$message.error("请输入新密码...");
      } else if (this.input4 == "") {
        this.$message.error("请输入确认新密码...");
      } else if (this.input3 != this.input4) {
        this.$message.error("两次输入的密码不一致...");
      } else {
        resetPassword({
          username: this.obj.username,
          password: this.input3,
          // orgId: this.obj.orgId,
          id: this.obj.id
        }).then(res => {
          if (res.code == 200) {
            this._login(this.obj.username, this.input3);
            this.input3 = "";
            this.input4 = "";
            this.centerDialogVisibles = false;
            console.log(123)
          } else {
            this.$message.error(`${res.msg}`);
          }
        }).catch(err => {
          console.log(err);
        });
      }
    },
    fixedPaaword() {
      this.centerDialogVisible = true;
    },
    sendBtn() {
      if (this.isResetpwd) {
        if (this.password == "") {
          this.$message.error("请输入新密码...");
          return;
        } else if (this.checkPwd == "") {
          this.$message.error("请输入确认新密码...");
          return;
        } else if (this.password != this.checkPwd) {
          this.$message.error("两次输入的密码不一致...");
          return;
        }
        this.loading = true;
        this.retSubmit();
      } else {
        this.$refs["infoForm"].validate(valid => {
          if (valid) {
            this.loading = true;
            this.retSubmit();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    retSubmit() {
      update({
        id: this.ruleForm.id,
        userId: this.ruleForm.userId,
        username: this.ruleForm.username,
        password: this.ruleForm.password,
        phone: this.ruleForm.phone,
        email: this.ruleForm.email,
        menuId: this.ruleForm.menuId,
        orgId: this.ruleForm.orgId
      })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "用户信息修改成功~！",
              type: "success"
            });
            this.loading = false;
            this.isResetpwd = false;
            this.password = "";
            this.checkPwd = "";
            localStorage.setItem("userInfos", JSON.stringify(this.ruleForm));
            this.centerDialogVisible = false;
          } else {
            this.loading = false;
            this.$message.error(`${res.msg}`);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    _getList() {
      list({
        username: JSON.parse(localStorage.getItem("userInfos")).username,
        orgId: JSON.parse(localStorage.getItem("userInfos")).orgId
      })
        .then(res => {
          if (res.code == 200) {
            let data = localStorage.getItem("userInfo");
            let arr = data.split(",");
            res.data.forEach(element => {
              for (let i = 0; i < arr.length; i++) {
                if (element.menuId == arr[i] && element.menuPlatform === 0) {
                  this.list.push(element);
                }
              }
            });
            // console.log(4 - this.list.length%4)
            this.total = 4 - (this.list.length % 4);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    jump(item) {
      if (item.menuName == "账户管理") {
        this.$router.push({
          path: "/list"
        });
      } else if (item.menuName == "OA系统") {
        let seesionId = localStorage.getItem("sessionId");
        window.open(`${item.loginUrl}?session_id=` + seesionId, "_blank");
      } else {
        let seesionId = localStorage.getItem("sessionId");
        window.open(`${item.loginUrl}?session_id=` + seesionId, "_blank");
      }
    },
    _login(username, password) {
      login({
        username: username,
        password: password
      }).then(res => {
        if (res.code == 200) {
          localStorage.setItem('sessionId', res.data.sessionId)
          localStorage.setItem('session_pc', res.data.sessionId)
          localStorage.setItem('userInfo', res.data.userInfo.menuId)
          localStorage.setItem('userInfos', JSON.stringify(res.data.userInfo))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    logout() {
      console.log(localStorage.getItem("sessionId"));
      axios
        .get(`/logout/${localStorage.getItem("sessionId")}`)
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            localStorage.removeItem("sessionId");
            localStorage.removeItem("session_pc");
            this.$router.replace({
              path: "/login"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Home.vue